<template>
  <div class="flex flex-col">
    <span class="font-bold text-gray-dark text-xl">API call</span>

    <span class="font-bold text-gray-dark mt-4">Request payload</span>
    <json-input class="mt-2" v-model="json" autofocus/>
    <span v-if="isErrorBubbleFocused" class="mt-1 text-xs text-focus-error">
      {{ errorDescription }}
    </span>
    <div class="mt-2">
      Request's <b>body</b> must be a valid JSON. For example:
      <i>{"name":"amio","email":"amio@amio.io"}</i>
    </div>

    <span class="font-bold text-gray-dark mt-4">Response</span>
    <span>2 ways to access the response for Conditions:</span>
    <div class="flex">
      <span>•<i>${context.apiCall.body.pathToYourApi}</i></span>
      <vx-tooltip ref="pathToYourApi"
                  class="flex items-center"
                  :text="pathToYourApiCopied ? 'PathToYourApi key was copied to your clipboard!' : 'Copy pathToYourApi response key.'"
      >
        <copy-icon class="h-5 ml-1 text-gray-dark hover:text-primary-focus cursor-pointer"
                   :is-copied="pathToYourApiCopied"
                   @click.native="copyContextKey('body.pathToYourApi', 'pathToYourApi')"
        />
      </vx-tooltip>
    </div>

    <div class="flex">
      <span>•<i>${context.apiCall.httpStatus}</i></span>
      <vx-tooltip ref="httpStatus"
                  class="flex items-center"
                  :text="httpStatusCopied ? 'HttpStatus key was copied to your clipboard!' : 'Copy httpStatus response key.'"
      >
        <copy-icon class="h-5 ml-1 text-gray-dark hover:text-primary-focus cursor-pointer"
                   :is-copied="httpStatusCopied"
                   @click.native="copyContextKey('httpStatus')"
        />
      </vx-tooltip>
    </div>

    <base-button variant="bordered-error" class="w-full mt-8" @click="removeApiCall">
      Remove API call
    </base-button>
  </div>
</template>

<script>
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import conversationModule from '@/store/modules/conversation.module'
import previewModule from '@/store/modules/preview.module'
import templateModule from '@/store/modules/template.module'
import tailwind from '../../../tailwind.config'
import stateTreeUtils from '@/utils/state-tree.utils'
import answerController from '@/controllers/answer.controller'
import templateController from '@/controllers/template.controller'
import JsonInput from '@/components/base-components/JsonInput.vue'
import CopyIcon from '@/assets/images/icons/CopyIcon.vue'

export default {
  name: 'ApiCallEditor',

  components: { JsonInput, CopyIcon },

  data() {
    return {
      pathToYourApiCopied: false,
      httpStatusCopied: false
    }
  },

  computed: {
    bubbleSelected: chatBubbleModule.bubbleSelected,
    stateTree: chatBubbleModule.stateTree,
    template: templateModule.template,
    error: previewModule.error,
    errorDescription: previewModule.errorDescription,

    isErrorBubbleFocused() {
      return chatBubbleModule.isErrorBubbleFocused()
    },

    focusColor() {
      return tailwind.theme.colors.focus
    },

    stateId() {
      return this.bubbleSelected.stateId
    },

    actionId() {
      return this.bubbleSelected.actionId
    },

    action() {
      return conversationModule.getAction(this.stateId, this.actionId)
    },

    previewController() {
      return templateModule.isTemplateEditor() ? templateController : answerController
    },

    json: {
      get() {
        return this.action
      },

      set(json) {
        this.updateRemoteAction(json)
        this.error = null
      }
    }
  },

  methods: {
    removeApiCall() {
      const node = stateTreeUtils.findNode(this.stateTree, this.bubbleSelected)
      this.previewController.removeBubble(node, this.template?.id)
    },

    updateRemoteAction(json) {
      conversationModule.updateRemoteAction(this.actionId, json)
    },

    async copyContextKey(key, tooltip = 'httpStatus') {
      this[`${tooltip}Copied`] = true
      await this.$copyText('${context.apiCall.' + key + '}')
      this.$refs[tooltip]?.mouseenterx()
      await this.sleep(2000)
      this[`${tooltip}Copied`] = false
      this.$refs[tooltip]?.mouseleavex()
    }
  }
}
</script>
